import { AddToWalletIcon } from '@ankr.com/ui';
import { Chain } from '@ankr.com/chains-list';

import {
  AddNetworkDialog,
  useAddNetworkDialog,
} from 'modules/wallet/components/AddNetworkDialog';
import { UpgradeAccountDialog } from 'modules/common/components/UpgradeAccountDialog';
import { hasPublicSubchains } from 'modules/chains/utils/hasPublicSubchains';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useAuthInstance } from 'modules/auth/hooks/useAuthInstance';
import { useDialog } from 'modules/common/hooks/useDialog';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { ChainMenuItem } from '../ChainMenuItem';
import { addToWalletMenuItemTranslation } from './translation';

interface AddToWalletMenuItemProps {
  chain: Chain;
  closeMenu: () => void;
}

export const AddToWalletMenuItem = ({
  chain,
  closeMenu,
}: AddToWalletMenuItemProps) => {
  const { isSignedIn } = useAuthInstance();

  const { isFreemium } = useAccountStatus();

  const {
    isOpened: isUpgradeAccountDialogOpened,
    onClose: closeUpgradeAccountDialog,
    onOpen: openUpgradeAccountDialog,
  } = useDialog();

  const {
    closeAddNetworkDialog,
    isAddNetworkDialogOpened,
    openAddNetworkDialog,
  } = useAddNetworkDialog();

  const { keys, t } = useTranslation(addToWalletMenuItemTranslation);

  const onClick = () => {
    closeMenu();

    const isPublicBlocked = !isSignedIn && !hasPublicSubchains(chain);
    const isFreemiumBlocked = isSignedIn && isFreemium && chain.premiumOnly;

    if (isPublicBlocked || isFreemiumBlocked) {
      openUpgradeAccountDialog();
    } else {
      openAddNetworkDialog();
    }
  };

  return (
    <>
      <ChainMenuItem Icon={AddToWalletIcon} onClick={onClick}>
        {t(keys.addToWallet)}
      </ChainMenuItem>
      <AddNetworkDialog
        chain={chain}
        isOpened={isAddNetworkDialogOpened}
        onClose={closeAddNetworkDialog}
      />
      <UpgradeAccountDialog
        isOpened={isUpgradeAccountDialogOpened}
        onClose={closeUpgradeAccountDialog}
      />
    </>
  );
};
